import { Row, Col, Descriptions, Tabs, Card } from "antd";
import { formatacaoData, formataData } from "../../services/funcoes";
import moment from "moment";

export default function DetalheVeiculo({ dadosModal }) {

    const veiculo = dadosModal || {};

    function displayValue(value, fallback = 'NÃO INFORMADO') {
        return value ? value : fallback;
    }

    return (
        <div>
            <Card title="Identificação do Cliente"
                size="small"
                className='card-top'
                styles={{ header: { backgroundColor: '#f1f1f1' } }}
            >
                <Descriptions size="small" labelStyle={{ fontWeight: 'bold' }}>
                    <Descriptions.Item label="Nome">
                        {displayValue(veiculo.pes_nome)}
                    </Descriptions.Item>
                    <Descriptions.Item label={veiculo.pef_cpf?.numero ? "CPF" : "CNPJ"}>
                        {veiculo.pef_cpf?.numero ?? veiculo.pej_cnpj?.numero}
                    </Descriptions.Item>
                </Descriptions>
            </Card>
            <Card title='Dados do Veículo'
                size='small'
                className='card-bottom'
                styles={{ header: { backgroundColor: '#f1f1f1', borderTopLeftRadius: 0, borderTopRightRadius: 0 } }}
            >
                <Descriptions column={{ xxl: 3, xl: 3, lg: 3, md: 2, sm: 2, xs: 1 }} size="small" labelStyle={{ fontWeight: 'bold' }}>
                    <Descriptions.Item label="Modelo do Veículo">
                        {displayValue(veiculo.vec_modelo)}
                    </Descriptions.Item>
                    <Descriptions.Item label="Marca Veiculo">
                        {displayValue(veiculo.mav_descricao)}
                    </Descriptions.Item>
                    <Descriptions.Item label="Placa">
                        {displayValue(veiculo.vec_placa)}
                    </Descriptions.Item>
                    <Descriptions.Item label="Ano de fabricação">
                        {displayValue(veiculo.vec_anofabricacao)}
                    </Descriptions.Item>
                    <Descriptions.Item label="Ano do Modelo">
                        {displayValue(veiculo.vec_anomodelo)}
                    </Descriptions.Item>
                    <Descriptions.Item label="Chassis">
                        {displayValue(veiculo.vec_chassi)}
                    </Descriptions.Item>
                    <Descriptions.Item label="Data de Cadastro">
                        {formataData(veiculo.vec_datacadastro)}
                    </Descriptions.Item>
                    <Descriptions.Item label="Cidade/UF">
                        {`${veiculo.cid_descricao}, ${veiculo.est_sigla}`}
                    </Descriptions.Item>
                    <Descriptions.Item label="Endereço">
                        {veiculo.log_logradouro ? `${veiculo.log_logradouro} - ${veiculo.bai_nome || 'BAIRRO NÃO INFORMADO'}` : "ENDEREÇO NÃO INFORMADO"}
                    </Descriptions.Item>
                </Descriptions>
            </Card>
        </div >
    );
}